<template>
    <div class="ReportDownloader" v-if="CheckPermission(PermissionRequirement)">
        <p class="link-like" @click="OpenReportOptions"><font-awesome-icon :icon="['fa', 'download']" /> {{ReportLabel}}</p>


        <b-modal ref="component-modal" :title="'Options for ' + ReportLabel" hide-footer>
            <b-container>
                <b-form @submit="RunReport" ref="form">
                    <b-row>
                        <p v-html="ReportDescription"></p>
                    </b-row>
                    <b-row>
                        <!--FORM BLOCK IMPLEMENTATION-->
                        <b-col v-if="FormBlockSchema">

                            <FormBlock :form-block-item="FormBlockSchema" />

                        </b-col>
                        <!--PARAMETER SCHEMA IMPLEMENTATION-->
                        <b-col v-if="ParameterSchema">
                            <div class="form-group" v-for="parameter in ParameterSchema">
                                <label>{{parameter.Label}}</label>
                                <!--SELECT-->
                                <select v-if="parameter.Type == 'Select'" :name="parameter.Name" :required="parameter.Required" class="form-control">
                                    <option selected value=""></option>
                                    <option v-for="option in parameter.Options" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                                <!--Multi Select-->
                                <multiselect :allow-empty="false" v-if="parameter.Type == 'MultiSelect'" :name="parameter.text" v-model="MultiSelect" :options="parameter.Options" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Programs" label="text" track-by="text" :preselect-first="true">
                                </multiselect>
                                <!--CheckBoxPrefixed-->
                                <div v-if="parameter.Type == 'CheckBoxPrefixed'">
                                    <p><span @click="CheckAll(parameter)" class="link-like">[CHECK ALL]</span> <span @click="UnCheckAll(parameter)" class="link-like">[UN-CHECK ALL]</span></p>
                                    <div v-for="option in parameter.Options">
                                        <input type="checkbox" :name="parameter.Name + option.nameSuffix" v-model="option.checked" :value="option.text" /> {{option.text}}
                                    </div>
                                </div>
                                <!--CheckBoxBool-->
                                <div v-if="parameter.Type == 'CheckBoxBool'">
                                    <div v-for="option in parameter.Options">
                                        <input type="checkbox" :name="option.name" v-model="option.checked" :value="true" /> {{option.text}}
                                    </div>
                                </div>
                                <!--HIDDEN CONSTANT-->
                                <input type="hidden" v-if="parameter.Type == 'HiddenConstant'" :name="parameter.Name" :value="parameter.Value" />
                                <p>{{parameter.DisplayValue}}</p>
                                <!--NUMBER-->
                                <input type="number" v-if="parameter.Type == 'Number'" :name="parameter.Name" class="form-control" />
                                <!--String-->
                                <input type="text" v-if="parameter.Type == 'String'" :name="parameter.Name" class="form-control" />
                                <!--DATE PICKER-->
                                <flat-pickr v-if="parameter.Type == 'Date'" :name="parameter.Name" class="form-control" required :config="parameter.CustomDateConfig ? parameter.CustomDateConfig : DateConfig"></flat-pickr>
                                <!--FILE UPLOAD-->
                                <b-form-file v-if="parameter.Type == 'FileUpload'" class="form-control"
                                             :name="parameter.Name"
                                             :accept="parameter.Accept"
                                             :required="parameter.Required"
                                             no-drop>
                                </b-form-file>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                <font-awesome-icon :icon="['fa', 'download']" /> DOWNLOAD REPORT
                            </b-button>
                        </div>

                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileExcel);
    //import components
    import FormBlock from "../../Core/RecordComponents/FormBlock.vue";
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Multiselect from 'vue-multiselect'

    export default {
        props: [
            "ReportLabel",
            "Endpoint",
            "FormBlockSchema",
            "ParameterSchema",
            "PermissionRequirement",
            "ReportDescription",
            "Method"
        ],
        data: function () {
            return {
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false
                },
                CallbackOptions: {},
                MultiSelect: [],
            };
        },
        methods: {
            OpenReportOptions() {
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            RunReport(e) {
                e.preventDefault();
                let form = this.$refs['form'];
                let formData = new FormData(form);
                let formKeys = formData.keys();

                let formValues = formData.values();
                let payload = {};
                if (this.MultiSelect.length > 0) {
                    let commaSeperated = this.MultiSelect.map(sp => sp.value).join(',');
                    payload = {
                        Id: commaSeperated
                    }
                }
                formData.forEach(function (value, key) {
                    payload[key] = value;
                });
                if (this.Method == "POST") {
                    this.$MasterAPI.ExecuteFileRequestPostForm(this.Endpoint, formData)
                } else {
                    this.$MasterAPI.ExecuteFileRequest(this.Endpoint, payload)
                }
                
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            CheckAll(param) {
                param.Options.forEach(function (o) {
                    o.checked = true;
                });
            },
            UnCheckAll(param) {
                param.Options.forEach(function (o) {
                    o.checked = false;
                });
            }
        },
        computed: {

        },
        components: {
            FormBlock,
            flatPickr,
            Multiselect
        }
        //mounted() {
        //    this.getUsers();
        //    console.log("ran get users method");
        //}
    }
</script>

<style scoped>

</style>